import React, { useContext, useState, useEffect } from 'react'
import Session from '../context/SessionContext'
import { DataContext } from '../context/DataContext'

import { LearningLabsViews, getLearningLabsView, GroupedModules, getGroupedLabModules } from '../Reporting'
import LoadingIndicator from './LoadingIndicator'
import TileView from './dataview/TileView'
import { LLModuleProfile } from '../interfaces/ModuleTypes'
import { PrimaryHeader } from '../styles/Styles'

const LearningLabs: React.FC = () => {
    const { user } = useContext(Session)
    const { labProfiles } = useContext(DataContext)
    const [dataViews, setDataViews] = useState<LearningLabsViews>()

    useEffect(() => {
        if (!labProfiles) return

        const groupedLabs: GroupedModules[] = getGroupedLabModules(labProfiles)
        const dataViews = {
            overall: getLearningLabsView(labProfiles),
            groupedModules: groupedLabs
        }
        setDataViews(dataViews)

    }, [labProfiles, user.companyId])

    if (!dataViews) return <LoadingIndicator loading={true} timeout={250} />
    return (
        <>
            <PrimaryHeader variant={'h4'}>
                {`Learning Labs Data`}
            </PrimaryHeader>
            <TileView dataTiles={dataViews.overall} />
            {
                dataViews.groupedModules.map((lab, index) => <TileView key={'lltv' + index} title={lab.moduleName} dataTiles={getLearningLabsView(lab.profiles as LLModuleProfile[])} />)
            }
        </>
    )
}

export default LearningLabs

